import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { GetSystemsByIntegratorResponse } from "../api/GetSystemsByIntegratorResponse";
import { useAdminSystemApi } from "../api/useAdminSystemApi";
import { mapToSystemItem, SystemItem } from "../listing/SystemItem";
import { SystemContext } from "./SystemContext";

interface SystemProviderProps {
    children: React.ReactNode;
}

export const SystemProvider: React.FC<SystemProviderProps> = (props: SystemProviderProps) => {
    const { children } = props;
    const { getSystemsByIntegrator } = useAdminSystemApi();
    const { integratorId } = useParams<{ integratorId: string }>();

    const [systemItems, setSystemItems] = useState<SystemItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getSystemsByIntegrator({ integratorId })
            .then((response: GetSystemsByIntegratorResponse) => {
                const systems = response.items.map(mapToSystemItem);

                setSystemItems(systems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const updateSystemItem = (updatedSystem: SystemItem) => {
        const updatedSystemList = getUpdatedSystemList(updatedSystem, systemItems);

        setSystemItems(updatedSystemList);
    };

    const addSystemItem = (item: SystemItem) => {
        setSystemItems((prevState) => [
            ...prevState,
            {
                id: item.id,
                name: item.name,
                description: item.description,
                updatedDate: item.updatedDate,
                isModified: true
            }
        ]);
    };

    return (
        <SystemContext.Provider value={{ systemItems, isLoading, addSystemItem, updateSystemItem }}>
            {children}
        </SystemContext.Provider>
    );
};

const getUpdatedSystemList = (updatedSystem: SystemItem, systemList: SystemItem[]): SystemItem[] => {
    return systemList.map((system: SystemItem) =>
        system.id === updatedSystem.id
            ? {
                  ...system,
                  name: updatedSystem.name,
                  description: updatedSystem.description,
                  updatedDate: updatedSystem.updatedDate,
                  isModified: true
              }
            : system
    );
};
